import { ACCOUNTS_ROUTES } from '../constants/routePaths'
import { formatRoute } from 'react-router-named-routes'
import accountsTypes from '../constants/accountsTypes'
import { axios } from '../services'

import { try_force_logoff } from './authActions'

const reset_account_errors = () => {
  return {
    type: accountsTypes.reset_errors
  }
}

// INDEX
const accounts_index_request = () => {
  return {
    type: accountsTypes.index.request
  }
}

const accounts_index_success = (response) => {
  return {
    type: accountsTypes.index.success,
    payload: response.data
  }
}

const accounts_index_failure = (messages) => {
  return {
    type: accountsTypes.index.failure,
    payload: messages
  }
}

const accounts_index = (page=1, filters={}) => {
  return function (dispatch) {
    // Before Request
    dispatch(accounts_index_request())

    // Request
    axios.get(
      ACCOUNTS_ROUTES.index,
      {
        params: {
          page: page,
          per_page: 10,
          filters: filters
        }
      }
    ).then( response => {
      // success
      dispatch( accounts_index_success(response) )
    }).catch( error=> {
      // failure
      let errors
      if (error.response && error.response.data && error.response.data.errors) {
        errors = error.response.data.errors
      } else {
        errors = ["Error fetching accounts."]
      }
      dispatch( try_force_logoff(error.response.data) )
      dispatch( accounts_index_failure(errors))
    })
  }
}

// AUTOCOMPLETE
const accounts_autocomplete_request = () => {
  return {
    type: accountsTypes.autocomplete.request
  }
}

const accounts_autocomplete_success = (query, response) => {
  const data = {
    ...response.data,
    query: query
  }
  return {
    type: accountsTypes.autocomplete.success,
    payload: data
  }
}

const accounts_autocomplete_filter_success = (query, response) => {
  const data = {
    ...response.data,
    query: query
  }
  return {
    type: accountsTypes.autocomplete.filter_success,
    payload: data
  }
}


const accounts_autocomplete_failure = (messages) => {
  return {
    type: accountsTypes.autocomplete.failure,
    payload: messages
  }
}

const accounts_autocomplete = (query) => {
  return function (dispatch) {
    // Before Request
    dispatch(accounts_autocomplete_request())

    // Request
    axios.get(
      ACCOUNTS_ROUTES.autocomplete,
      {
        params: {
          q: query
        }
      }
    ).then( response => {
      // success
      dispatch( accounts_autocomplete_success(query, response) )
    }).catch( error=> {
      // failure
      let errors
      if (error.response && error.response.data && error.response.data.errors) {
        errors = error.response.data.errors
      } else {
        errors = ["Error fetching accounts."]
      }
      dispatch( try_force_logoff(error.response.data) )
      dispatch( accounts_autocomplete_failure(errors))
    })
  }
}

const accounts_autocomplete_filter = (query) => {
  return function (dispatch) {
    // Before Request
    dispatch(accounts_autocomplete_request())

    // Request
    axios.get(
      ACCOUNTS_ROUTES.autocomplete,
      {
        params: {
          q: query
        }
      }
    ).then( response => {
      // success
      dispatch( accounts_autocomplete_filter_success(query, response) )
    }).catch( error=> {
      // failure
      let errors
      if (error.response && error.response.data && error.response.data.errors) {
        errors = error.response.data.errors
      } else {
        errors = ["Error fetching accounts."]
      }
      dispatch( try_force_logoff(error.response.data) )
      dispatch( accounts_autocomplete_failure(errors))
    })
  }
}

const accounts_autocomplete_reset = () => {
  return {
    type: accountsTypes.autocomplete.reset
  }
}

// LOCK = DISABLE, ACTIVATE = ENABLE
const lock_account_request = () => {
  return {
    type: accountsTypes.lock.request
  }
}

const lock_account_success = (response) => {
  return {
    type: accountsTypes.lock.success,
    payload: response.data
  }
}

const lock_account_failure = (messages) => {
  return {
    type: accountsTypes.lock.failure,
    payload: messages
  }
}

const lock_account = (account_id) => {
  return function (dispatch) {
    // Before Request
    dispatch(lock_account_request())

    // Request
    axios.post(
      formatRoute(ACCOUNTS_ROUTES.lock, {id: account_id})
    ).then( response => {
      // success
      dispatch( lock_account_success(response) )
    }).catch( error=> {
      // failure
      let errors
      if (error.response && error.response.data && error.response.data.errors) {
        errors = error.response.data.errors
      } else {
        errors = ["Error locking account."]
      }
      dispatch( try_force_logoff(error.response.data) )
      dispatch( lock_account_failure(errors))
    })
  }
}

const activate_account = (account_id) => {
  return function (dispatch) {
    // Before Request
    dispatch(lock_account_request())

    // Request
    axios.post(
      formatRoute(ACCOUNTS_ROUTES.activate, {id: account_id})
    ).then( response => {
      // success
      dispatch( lock_account_success(response) )
    }).catch( error=> {
      // failure
      let errors
      if (error.response && error.response.data && error.response.data.errors) {
        errors = error.response.data.errors
      } else {
        errors = ["Error activating account."]
      }
      dispatch( try_force_logoff(error.response.data) )
      dispatch( lock_account_failure(errors))
    })
  }
}

// UPDATE
const update_account_request = () => {
  return {
    type: accountsTypes.update.request
  }
}

const update_account_success = (response) => {
  return {
    type: accountsTypes.update.success,
    payload: response.data
  }
}

const update_account_failure = (messages) => {
  return {
    type: accountsTypes.update.failure,
    payload: messages
  }
}

const update_account = (account_id, values) => {
  return function (dispatch) {
    // Before Request
    dispatch(update_account_request())

    // Request
    axios.patch(
      formatRoute(ACCOUNTS_ROUTES.update, {id: account_id}),
      values
    ).then( response => {
      // success
      dispatch( update_account_success(response) )
    }).catch( error=> {
      // failure
      let errors
      if (error.response && error.response.data && error.response.data.errors) {
        errors = error.response.data.errors
      } else {
        errors = ["Error updating account."]
      }
      dispatch( try_force_logoff(error.response) )
      dispatch( update_account_failure(errors))
    })
  }
}

// DELETE
const destroy_account_request = () => {
  return {
    type: accountsTypes.destroy.request
  }
}

const destroy_account_success = (response) => {
  return {
    type: accountsTypes.destroy.success,
    payload: response.data
  }
}

const destroy_account_failure = (messages) => {
  return {
    type: accountsTypes.destroy.failure,
    payload: messages
  }
}

const destroy_account = (account_id, page=1, per_page=10) => {
  return function (dispatch) {
    // Before Request
    dispatch(destroy_account_request())

    // Request
    axios.delete(
      formatRoute(ACCOUNTS_ROUTES.destroy, {id: account_id}),
      {
        page: page,
        per_page: per_page
      }
    ).then( response => {
      // success
      dispatch( destroy_account_success(response) )
    }).catch( error=> {
      // failure
      let errors
      if (error.response && error.response.data && error.response.data.errors) {
        errors = error.response.data.errors
      } else {
        errors = ["Error deleting account."]
      }
      dispatch( try_force_logoff(error.response.data) )
      dispatch( destroy_account_failure(errors))
    })
  }
}

// CREATE
const create_account_init = () => {
  return {
    type: accountsTypes.create.init
  }
}

const create_account_request = () => {
  return {
    type: accountsTypes.create.request
  }
}

const create_account_success = (response) => {
  return {
    type: accountsTypes.create.success,
    payload: response.data
  }
}

const create_account_failure = (messages) => {
  return {
    type: accountsTypes.create.failure,
    payload: messages
  }
}

const create_account = (values) => {
  return function (dispatch) {
    // Before Request
    dispatch(create_account_request())

    // Request
    axios.post(
      ACCOUNTS_ROUTES.create,
      values
    ).then( response => {
      // success
      dispatch( create_account_success(response) )
    }).catch( error=> {
      // failure
      let errors
      if (error.response && error.response.data && error.response.data.errors) {
        errors = error.response.data.errors
      } else {
        errors = ["Error creating account."]
      }
      dispatch( try_force_logoff(error.response) )
      dispatch( create_account_failure(errors))
    })
  }
}

export {
  reset_account_errors,
  accounts_index,
  accounts_autocomplete,
  accounts_autocomplete_filter,
  accounts_autocomplete_reset,
  lock_account,
  activate_account,
  update_account,
  destroy_account,
  create_account_init,
  create_account
}



// WEBPACK FOOTER //
// ./src/js/actions/accountsActions.js